import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { selectGroupGuid, useAppSelector } from '../../slices/commonSelectors';
import { toast } from 'react-toastify';
import { keys } from './useLocations';
import { LocationResourcesWithBooms } from 'types/locations';
import { LocationInput } from '../../types/locations';
import { prettifiedResourceType } from './prettifiedResourceType';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';

export const useCreateLocation = () => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);

  return useMutation({
    mutationFn: async (location: LocationInput) => {
      const response = await axios.post(config.apiGateway.ics_locations, {
        ...location,
        groupGuid,
      });
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [keys.locations, groupGuid, variables.resourceType],
      });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });

      const resourceTypeText = prettifiedResourceType(data.resourceType);
      toast.success(`${resourceTypeText} created successfully`);
    },
    onError: (_err, { resourceType }) => {
      const resourceTypeText = prettifiedResourceType(
        resourceType as LocationResourcesWithBooms
      );
      toast.error(`Failed to create ${resourceTypeText}. Please try again.`);
    },
  });
};
